import SideBar from "../components/sideBar";
import translateText, { currentLanguage } from "../signals/language.signal";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import { primaryFount } from "../signals/Theme colors.signal";
import QRCode from "qrcode.react";
import {
  PropCouponTypeData,
  PropCouponColor,
  couponsData,
  fetchCouponsApi,
} from "../signals/couponsData.signal";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { logClientName } from "../signals/login.signal";
import { getCurrencySymbol } from "../components/CurrencySymbol";
const CouponDetails = () => {
  const navigate = useNavigate();

  useEffect(() => {
    couponsData.value = "";
    const fetchData = async (CouponTypeData) => {
      try {
        const result = await fetchCouponsApi(CouponTypeData);
        couponsData.value = result;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    !PropCouponTypeData.value
      ? navigate("/coupon")
      : fetchData(PropCouponTypeData.value);
  }, []);
  return (
    <div
      className="position-absolute top-0 w-100"
      style={{ background: "#fff" }}
    >
      <SideBar
        more={true}
        back={true}
        backFunction={() => {
          PropCouponTypeData.value = "";
          navigate(-1);
        }}
        title={translateText(currentLanguage.value, "CouponList")}
      />

      <div
        id="loginPage"
        className=" flex-column flex-sm-row justify-content-center align-items-sm-center d-flex  w-100  p-3 flex-wrap"
      >
        {couponsData.value ? (
          couponsData.value.length != 0 ? (
            couponsData.value.map((data) => (
              <div
                data-aos="fade-up"
                data-aos-duration="2000"
                key={data.PROMOCODE}
                className="pt-3 pb-3 p-md-3"
                style={{ maxWidth: 450 }}
              >
                <div
                  className=" loginContaner position-relative mb-1 p-3 border w-100   rounded-3 "
                  style={{
                    background: PropCouponColor.value,
                    color: primaryFount.value,
                    maxWidth: 450,
                  }}
                >
                  <div className="w-100 d-flex">
                    <div
                      className="position-absolute rounded-circle"
                      style={{
                        background: "#fbfbfb",
                        height: "30px",
                        width: "30px",
                        transform: "translate(calc(100% + -45px), 50%)",
                        left: "0",
                      }}
                    ></div>
                    <CardGiftcardIcon
                      className="  m-0 ps-3"
                      style={{ fontSize: "64px", marginRight: "10px" }}
                    />
                    <div
                      className="ms-3 w-auto h-auto border-1 me-3"
                      style={{ border: "dashed" }}
                    ></div>
                    <div className=" w-100 ">
                      <p className="m-0 " style={{ fontSize: "12px" }}>
                        {translateText(currentLanguage.value, "Balance")}
                      </p>
                      <p
                        className="form-label  "
                        style={{
                          fontSize: "35px",
                          fontWeight: "700px",
                          width: "fit-content",
                        }}
                        dir="ltr"
                      >
                        {getCurrencySymbol(primaryFount.value)}
                        {data.DISCOUNT}
                      </p>
                    </div>
                    <div
                      className="position-absolute rounded-circle"
                      style={{
                        background: "#fbfbfb",
                        height: "30px",
                        width: "30px",
                        transform: "translate(calc(100% + -15px), 50%)",
                        right: "0",
                      }}
                    ></div>
                  </div>
                  <div
                    className="rounded-3 shadow-sm w-100 mt-3 d-flex justify-content-around align-items-center"
                    style={{ background: "#fff", height: 100 }}
                  >
                    <div className="d-flex justify-content-center align-items-center">
                      <QRCode
                        value={data.PROMOCODE}
                        style={{ height: "75px", width: "75px" }}
                      />
                    </div>
                    <div
                      className="align-content-center d-flex flex-column flex-row justify-content-around m-0 h-100"
                      style={{ color: "#000", fontSize: 12, width: "60%" }}
                    >
                      <div className="text-center" style={{ fontSize: 12 }}>
                        {logClientName.value}
                      </div>
                      <table
                        cellPadding={0}
                        cellSpacing={0}
                        className="tayble ms-3 me-3 w-100"
                      >
                        <tbody>
                          <tr>
                            <td valign="top" className="p-0">
                              <div style={{ fontSize: 12, fontWeight: "700" }}>
                                {translateText(
                                  currentLanguage.value,
                                  "ClientCode"
                                )}
                              </div>
                            </td>
                            <td className="p-0">
                              <div style={{ fontSize: 12 }}>{data.CLICODE}</div>
                            </td>
                          </tr>
                          <tr>
                            <td valign="top" className="p-0">
                              <div style={{ fontSize: 12, fontWeight: "700" }}>
                                {translateText(currentLanguage.value, "coupNo")}
                              </div>
                            </td>
                            <td className="p-0">
                              <div style={{ fontSize: 12 }}>
                                {" "}
                                {data.PROMOCODE}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td valign="top" className="p-0">
                              <div style={{ fontSize: 12, fontWeight: "700" }}>
                                {translateText(
                                  currentLanguage.value,
                                  "ExpiryDate"
                                )}
                              </div>
                            </td>
                            <td className="p-0">
                              <div style={{ fontSize: 12 }}>
                                {" "}
                                {data.EXPIRY_DATE}
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <>
              <div className="loginContaner bg-white p-3 p-md-5 flex-column w-100 shadow rounded-3 d-flex justify-content-center align-items-center">
                <h5>Coupons not found</h5>
              </div>
            </>
          )
        ) : (
          <>
            <div className="align-items-sm-center d-flex justify-content-center w-100  mb-1">
              <div className="align-items-sm-center loginContaner d-flex justify-content-center w-100">
                <div
                  style={{ height: "228.88px" }}
                  className=" skeleton p-md-5 flex-column w-100 shadow rounded-3 d-flex justify-content-center align-items-center"
                ></div>
              </div>
            </div>
            <div className="align-items-sm-center d-flex justify-content-center w-100  mb-1">
              <div className="align-items-sm-center loginContaner d-flex justify-content-center w-100">
                <div
                  style={{ height: "228.88px" }}
                  className=" skeleton p-md-5 flex-column w-100 shadow rounded-3 d-flex justify-content-center align-items-center"
                ></div>
              </div>
            </div>
            <div className="align-items-sm-center d-flex justify-content-center w-100  mb-1">
              <div className="align-items-sm-center loginContaner d-flex justify-content-center w-100">
                <div
                  style={{ height: "228.88px" }}
                  className=" skeleton p-md-5 flex-column w-100 shadow rounded-3 d-flex justify-content-center align-items-center"
                ></div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
export default CouponDetails;
